import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { Classroom } from '../interface/calendar';
import { LessonPlan } from '../interface/lesson-plan';
import { HttpService } from './http.service';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root',
})
export class TeacherLessonPlanService {
  instructionalPeriods = [];
  constructor(
    private httpService: HttpService,
    private utilService: UtilService,
  ) {}

  async addTeacherSubjectHours(body) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.TeacherSubjectHours}`, body),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      // console.log(error);
    }
  }

  async addAndUpdateMultipleSubjectHours(body) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.update_multiple_teacher_periods}`, body),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      // console.log(error);
    }
  }

  async getTeacherLessonPlanByClassroomIds(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.teacher_lesson_plan_by_classroom_ids}`,
          body,
        ),
      );
    } catch (error) {
      // console.log(error);
    }
  }

  async getStudentTeacherLessonPlan(body) {
    try {
      const lesssonPlanToken = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.student_teacher_lesson_plan}`, body),
      );
      return this.httpService.decodeTokenPagination(lesssonPlanToken);
    } catch (error) {
      // console.log(error);
    }
  }

  async getTeacherSubjectHours(queryParams, isDummy = false) {
    try {
      const url = isDummy ? EndPoint.teacher_subject_hours_by_dummy_user_id : EndPoint.TeacherSubjectHours;
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${url}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      // console.log(error);
    }
  }

  async getTeacherSubjectHoursByUserId(queryParams) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.TeacherSubjectHoursById}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      // console.log(error);
    }
  }

  async getTeacherSubjectHoursById(id) {
    try {
      return firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.TeacherSubjectHours}/${id}`),
      );
    } catch (error) {
      // console.log(error);
    }
  }

  async updateTeacherHours(id, body) {
    try {
      return firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.TeacherSubjectHours}/${id}`, body),
      );
    } catch (error) {
      // console.log(error);
    }
  }

  async delteTeacherPeriodHour(id: number) {
    try {
      return firstValueFrom(
        this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.TeacherSubjectHours}/${id}`),
      );
    } catch (error) {
      // console.log(error);
    }
  }

  getTeacherPeriodsFromEvents(
    classroom: Classroom,
    currentPlan: any,
    currentLessonPlanToPush: LessonPlan,
    iterator: any,
  ) {
    const subjectHours = classroom.extras['eventDates'].filter(
      (x) =>
        x.day === this.utilService.getWeekDayString(new Date(currentPlan.start).getDay()).toLowerCase() &&
        ((x.subject_id ?? x.subjectId) ? (x.subject_id ?? x.subjectId) === currentLessonPlanToPush.subject_id : true),
    );
    const subjectStartDate = new Date(subjectHours[0].start);
    const iteratorStartDate = new Date(iterator.start);
    // Set hours and minutes from subjectStartDate to iteratorDate
    iteratorStartDate.setHours(subjectStartDate.getHours(), subjectStartDate.getMinutes(), 0, 0);
    const iteratorStartTime = iteratorStartDate.toTimeString();
    const subjectEndDate = new Date(subjectHours[0].end);
    const iteratorEndDate = new Date(iterator.end);
    // Set hours and minutes from subjectStartDate to iteratorDate
    iteratorEndDate.setHours(subjectEndDate.getHours(), subjectEndDate.getMinutes(), 0, 0);
    const iteratorEndTime = iteratorEndDate.toTimeString();
    return { iteratorStartTime, iteratorEndTime };
  }
}
